module.exports = __webpack_public_path__ + "img/sidebar-background-3.89170993.svg";